<h2 mat-dialog-title>Nova Empresa</h2>

<div [formGroup]="empresaForm" mat-dialog-content class="dialog-scroll-content">

  <!-- Dados da Empresa -->
  <div class="row mt-2">
    <div class="col-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>CNPJ</mat-label>
        <input matInput mask="AA.AAA.AAA/AAAA-00" type="text" placeholder="XX.XXX.XXX/XXXX-XX" formControlName="cnpj" />
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-8">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Razão Social</mat-label>
        <input matInput type="text" placeholder="Razão Social" formControlName="razao_social" required />
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nome Fantasia</mat-label>
        <input matInput type="text" placeholder="Nome Fantasia" formControlName="nome_fantasia" />
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>

  <!-- Contato da Empresa -->
  <div class="row">
    <div class="col-7">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="Email" formControlName="email" required />
        <mat-error *ngIf="empresaForm.get('email')?.hasError('email')">Email inválido</mat-error>
        <mat-error *ngIf="empresaForm.get('email')?.hasError('required')">Campo obrigatório</mat-error>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-5">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Telefone</mat-label>
        <input matInput type="text" placeholder="(00) 00000-0000" formControlName="telefone"
          [mask]="empresaForm.get('telefone')?.value?.length <= 10 ? '(00) 0000-0000*' : '(00) 0 0000-0000'"
          [validation]="false" required />
        <mat-error *ngIf="empresaForm.get('telefone')?.hasError('required')">Campo obrigatório</mat-error>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>

  <!-- Endereço -->
  <div class="row">
    <div class="col-4">
      <app-busca-endereco
        icon="search"
        label="CEP"
        inputClasses="w-100"
        [control]="empresaForm.get('cep')"
        (endereco)="setEndereco($event)">
      </app-busca-endereco>
    </div>
    <div class="col-8">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Logradouro</mat-label>
        <input matInput type="text" placeholder="Logradouro" formControlName="logradouro" required />
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Número</mat-label>
        <input matInput type="text" placeholder="0000" formControlName="numero" />
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-9">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Complemento</mat-label>
        <input matInput type="text" placeholder="Complemento" formControlName="complemento" />
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-5">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Bairro</mat-label>
        <input matInput type="text" placeholder="Bairro" formControlName="bairro" required />
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-5">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Município / Cidade</mat-label>
        <input matInput type="text" placeholder="Município" formControlName="municipio" required />
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-2">
      <app-uf-select formControlName="uf"></app-uf-select>
    </div>
  </div>

  <hr class="my-3" />

  <!-- Cabeçalho da Seção de Representantes + Botão de Adicionar -->
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h6 class="m-0">Representantes</h6>
    <button mat-stroked-button color="primary" type="button" (click)="adicionarRepresentante()">
      + Adicionar Representante
    </button>
  </div>

  <!-- Lista Dinâmica de Representantes (FormArray) -->
  <div formArrayName="representantes">
    <div *ngFor="let rep of representantes.controls; let i = index" [formGroupName]="i" class="representante-bloco mb-3">

      <!-- Cabeçalho de cada representante (exibe botão de remover se houver mais de 1) -->
      <div class="d-flex justify-content-between align-items-center mb-2" *ngIf="representantes.length > 1">
        <span class="text-muted font-weight-bold">Representante {{ i + 1 }}</span>
        <button mat-button color="warn" type="button" (click)="removerRepresentante(i)">
          Remover
        </button>
      </div>

      <!-- Dados do Representante -->
      <div class="row">
        <div class="col-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>CPF do Representante</mat-label>
            <input matInput type="text" placeholder="000.000.000-00" mask="000.000.000-00" formControlName="cpf" required />
            <app-input-loading [isLoading]="loading"></app-input-loading>
          </mat-form-field>
        </div>
        <div class="col-5">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome do Representante</mat-label>
            <input matInput type="text" placeholder="Nome do Representante" formControlName="nome" required />
            <app-input-loading [isLoading]="loading"></app-input-loading>
          </mat-form-field>
        </div>
        <div class="col-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="tipo">
              <mat-option *ngFor="let tipo of tipos" [value]="tipo.value">
                {{ tipo.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Contato do Representante -->
      <div class="row">
        <div class="col-7">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Email do Representante</mat-label>
            <input matInput type="email" placeholder="Email do Representante" formControlName="email_representante" required />
            <mat-error *ngIf="rep.get('email_representante')?.hasError('email')">Email inválido</mat-error>
            <mat-error *ngIf="rep.get('email_representante')?.hasError('required')">Campo obrigatório</mat-error>
            <app-input-loading [isLoading]="loading"></app-input-loading>
          </mat-form-field>
        </div>
        <div class="col-5">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Telefone do Representante</mat-label>
            <input matInput type="text" placeholder="(00) 00000-0000" formControlName="tel_representante"
              [mask]="rep.get('tel_representante')?.value?.length <= 10 ? '(00) 0000-0000*' : '(00) 0 0000-0000'"
              [validation]="false" required />
            <mat-error *ngIf="rep.get('tel_representante')?.hasError('required')">Campo obrigatório</mat-error>
            <app-input-loading [isLoading]="loading"></app-input-loading>
          </mat-form-field>
        </div>
      </div>

      <!-- Linha divisória entre representantes -->
      <hr *ngIf="i < representantes.length - 1" class="my-2" />
    </div>
  </div>

</div>

<!-- Ações fora do mat-dialog-content para ficarem fixas no rodapé -->
<div mat-dialog-actions align="end" class="mt-2">
  <button mat-button [mat-dialog-close]="false" class="mr-2">
    Cancelar
  </button>
  <button mat-raised-button color="primary" (click)="closeDialog()" [disabled]="empresaForm.invalid">
    Salvar
  </button>
</div>
